export const getBreadcrumbs = (
  { product_name, title },
  secondLevelBreadcrumb
) => {
  let bulletinFields = {
    id: 3,
    active: true,
  };

  if (product_name) {
    bulletinFields.title = Array.isArray(product_name)
      ? product_name[0]
      : product_name;
  } else if (!product_name && title) {
    bulletinFields.title = title;
  }

  return {
    techassist: {
      id: 1,
      active: false,
      url: '/',
    },
    ...secondLevelBreadcrumb,
    bulletin: {
      ...bulletinFields,
    },
  };
};



// WEBPACK FOOTER //
// ./src/utils/documentsBreadcrumbsHelper.js